import React from "react";
import "./Stylesheets/FooterPro.css";

/**
 * OFEAA — Professional Footer
 * Pass your HQ object or use the default below.
 */
export default function FooterPro({
  hq = {
    name: "OFEAA Head Office",
    addressLine1: "808 Crystal Lake Road",
    addressLine2: "Kinmount, Ontario, K0M 2A0",
    phone: "+1-705-488-2660",
    phoneDisplay: "(705) 488-2660",
    fax: "+1-705-488-2835",
    faxDisplay: "(705) 488-2835",
    email: "info@ontarioaquaculture.net",
    websiteHref: "https://ontarioaquaculture.net",
    websiteText: "OntarioAquaculture.net",
  },
  orgName = "Ontario Fishery Enhancement & Aquaculture Association",
  year = new Date().getFullYear(),
}) {
  return (
    <footer className="ofeaa-footer" aria-label="Site footer">
      <div className="ofeaa-footer__top">
        {/* Brand / blurb */}
        <div className="ofeaa-footer__brand">
          <div className="ofeaa-footer__brand-title">{orgName}</div>
          <p className="ofeaa-footer__brand-copy">
            Supporting Ontario’s aquaculture community through advocacy, education, and responsible stewardship.
          </p>
        </div>

        {/* Head Office (your provided info, nicely styled) */}
        <section className="ofeaa-footer__card ofeaa-footer__hq" aria-label="Head office">
          <h2 className="ofeaa-footer__h2">{hq.name}</h2>
          <div className="ofeaa-footer__rows">
            <Row icon={<IconPin />}>
              <address className="ofeaa-footer__text not-italic">
                {hq.addressLine1}
                <br />
                {hq.addressLine2}
              </address>
            </Row>
            <Row icon={<IconPhone />}>
              <a className="ofeaa-footer__link" href={`tel:${hq.phone}`}>{hq.phoneDisplay}</a>
            </Row>
            <Row icon={<IconFax />}>
              <span className="ofeaa-footer__text">{hq.faxDisplay}</span>
            </Row>
            <Row icon={<IconMail />}>
              <a className="ofeaa-footer__link ofeaa-footer__link--wrap" href={`mailto:${hq.email}`}>
                {hq.email}
              </a>
            </Row>
            <Row icon={<IconGlobe />}>
              <a
                className="ofeaa-footer__link ofeaa-footer__link--wrap"
                href={hq.websiteHref}
                target="_blank"
                rel="noreferrer noopener"
              >
                {hq.websiteText}
              </a>
            </Row>
          </div>
        </section>

        {/* Quick links (optional – edit or remove) */}
        <nav className="ofeaa-footer__nav" aria-label="Footer navigation">
          <div className="ofeaa-footer__h2">Quick Links</div>
          <ul className="ofeaa-footer__list" role="list">
            <li><a className="ofeaa-footer__navlink" href="/about">About</a></li>
            <li><a className="ofeaa-footer__navlink" href="/contact">Contact</a></li>
            <li><a className="ofeaa-footer__navlink" href="/membership">Membership</a></li>
            <li><a className="ofeaa-footer__navlink" href="/resources">Resources</a></li>
          </ul>
        </nav>
      </div>

      <div className="ofeaa-footer__bottom">
        <div className="ofeaa-footer__legal">
          © {year} {orgName}. All rights reserved.
        </div>
        <div className="ofeaa-footer__legal-links">
          <a className="ofeaa-footer__tiny" href="/privacy">Privacy</a>
          <span aria-hidden="true">•</span>
          <a className="ofeaa-footer__tiny" href="/terms">Terms</a>
        </div>
      </div>
    </footer>
  );
}

/** Shared row with icon + content that wraps safely */
function Row({ icon, children }) {
  return (
    <div className="ofeaa-footer__row">
      <span className="ofeaa-footer__icon">{icon}</span>
      <div className="ofeaa-footer__content">{children}</div>
    </div>
  );
}

/* ===== Inline SVGs (no emojis) ===== */
function IconPhone(){return(<svg className="ic" viewBox="0 0 24 24" aria-hidden="true"><path d="M3 5a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h0a12 12 0 006 6h0a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-1C10.82 21 3 13.18 3 4V5z" fill="currentColor" opacity=".9"/></svg>)}
function IconFax(){return(<svg className="ic" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 3h12v6h3a1 1 0 011 1v9a2 2 0 01-2 2H4a2 2 0 01-2-2V10a1 1 0 011-1h3V3zm2 0v6h8V3H8zm1 10h6v2H9v-2zm0 3h6v2H9v-2z" fill="currentColor" opacity=".9"/></svg>)}
function IconMail(){return(<svg className="ic" viewBox="0 0 24 24" aria-hidden="true"><path d="M3 6a2 2 0 012-2h14a2 2 0 012 2v.5l-9 6-9-6V6zm0 3.2l8.4 5.6a2 2 0 002.2 0L22 9.2V18a2 2 0 01-2 2H4a2 2 0 01-2-2V9.2z" fill="currentColor" opacity=".9"/></svg>)}
function IconGlobe(){return(<svg className="ic" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3a9 9 0 100 18 9 9 0 000-18zm0 0c2.5 0 4.5 4 4.5 9S14.5 21 12 21 7.5 17 7.5 12 9.5 3 12 3zm-7 9h14" fill="none" stroke="currentColor" strokeWidth="1.6"/></svg>)}
function IconPin(){return(<svg className="ic" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2a7 7 0 00-7 7c0 5.25 7 13 7 13s7-7.75 7-13a7 7 0 00-7-7zm0 9.5a2.5 2.5 0 110-5 2.5 2.5 0 010 5z" fill="currentColor"/></svg>)}
